import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { useSurveyContext } from 'Views/Onboarding/Pages/Survey/SurveyContext';
import FixedBottom from 'Components/ComponentLibrary/Components/Uncategorized/FixedBottom';
import { useOnboardingFooter } from '../../../Contexts/OnboardingFooterContext';

const styles = theme => ({
  root: {
    maxWidth: 'inherit',
    backgroundColor: theme.palette.common.white,
  },
  rootHidden: {
    display: 'none',
  },
  content: {},
});

const SurveyContentFooter = ({
  className,
  classes,
}) => {
  const { fixedFooter, showFooter } = useSurveyContext();
  const { footerRef } = useOnboardingFooter();

  return (
    <>
      {fixedFooter ? (
        <FixedBottom
          ref={footerRef}
          className={classNames(classes.root, className, {
            [classes.rootHidden]: !showFooter,
          })}
          hasBottomNav={false}
        />
      ) : (
        <div
          className={classes.content}
          ref={footerRef}
        />
      )}
    </>
  );
};

SurveyContentFooter.defaultProps = {
  className: '',
};

SurveyContentFooter.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SurveyContentFooter);
